import { Component } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  ValidationErrors,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  ButtonComponent,
  PhoneMaskDirective,
  TextInputComponent,
} from 'ddmo-storybook-lib';
import { LABELS } from '../../../../shared/constants/lables.constants';
import { LoaderService } from '../../../../shared/services/loader.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile',
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    PhoneMaskDirective,
    ReactiveFormsModule,
    ButtonComponent,
    ButtonComponent,
    TextInputComponent,
    MatIconModule
  ],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss',
})
export class EditProfileComponent {
  mainError = '';
  errormessages = LABELS.ERROR_MESSAGES;
  isUpdated:boolean = false;
  formData = {
    username: '',
    password: '',
    confirmPassword: '',
    dentistFirstName: '',
    dentistLastName: '',
    licenseState: '',
    emailAddress: '',
  };
  PHONE_PATTERN = LABELS.PHONE_PATTERN;
  EMAIL_PATTERN = LABELS.EMAIL_PTTERN;
  passwordMismatchError: boolean = false;
  heading:string = 'Edit profile'
  public profileForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(this.EMAIL_PATTERN),
    ]),
    password: new FormControl('', [
      Validators.minLength(12),
    ]),
    confirmPassword: new FormControl(''),
    dentistFirstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern(LABELS.NUMBER_PATTERN),
      this.sharedService.noWhitespaceValidator(),
    ]),
    dentistLastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern(LABELS.NUMBER_PATTERN),
      this.sharedService.noWhitespaceValidator(),
    ]),
    licenseState: new FormControl('', Validators.required),
    phoneNumber: new FormControl('', [
      Validators.required,
      Validators.pattern(this.PHONE_PATTERN),
    ]),
  });
  constructor(
    private sharedService: SharedService,
    private loader: LoaderService,
    private dialogRef: MatDialogRef<EditProfileComponent>,
    private router: Router
  ) {}

  ngOnInit() {
    const loggedUserDetails = JSON.parse(
      localStorage.getItem('loggedUserDetails') || '{}',
    );
    if (loggedUserDetails) {
      this.profileForm.patchValue({
        email: loggedUserDetails.username,
        dentistFirstName:
          loggedUserDetails.firstName || loggedUserDetails.dentistFirstName,
        dentistLastName:
          loggedUserDetails.lastName || loggedUserDetails.dentistLastName,
        licenseState:
          loggedUserDetails.licenseState || loggedUserDetails.licenseState,
        phoneNumber: loggedUserDetails.phone || loggedUserDetails.phoneNumber,
      });
    }
    this.profileForm.get('email')?.disable();
    this.profileForm.get('licenseState')?.disable();
    this.Validatepassword();
    this.profileForm.updateValueAndValidity();
  }
  errormsg(fieldName: any) {
    if (fieldName == 'Password') {
      return {
        ...this.errormessages,
        minlength: `${fieldName} must be at least 12 characters long`,
        customFieldValidation: 'Password is too Weak',
      };
    }
    return {
      ...this.errormessages,
      minlength: `${fieldName} doesn't meet requirements`,
    };
  }
  confirmPasswordValidator(
    passwordValue: any,
    confirmValue: any,
  ): ValidationErrors | null {
    // if (!confirmValue || confirmValue.trim() === '') {
    //   return { required: true };
    // }
    if (passwordValue !== confirmValue) {
      return { mismatch: true };
    }
    return null;
  }
  private Validatepassword() {
    this.profileForm.controls['confirmPassword'].valueChanges.subscribe(
      (cnfValue: any) => {
        const passwordValue = this.profileForm.controls['password'].value;
        const error = this.confirmPasswordValidator(passwordValue, cnfValue);
        this.profileForm.controls['confirmPassword'].setErrors(error);
      },
    );

    this.profileForm.controls['password'].valueChanges.subscribe(
      (passwordValue: any) => {
        const cnfValue = this.profileForm.controls['confirmPassword'].value;
        const error = this.confirmPasswordValidator(passwordValue, cnfValue);
        this.profileForm.controls['confirmPassword'].setErrors(error);
      },
    );
  }
  updateProfile() {
    this.profileForm.markAllAsTouched();
    if (this.profileForm.invalid) return;
    this.loader.show();
    this.mainError = '';
    const formValue = this.profileForm.getRawValue();
    let auth0_user_id=localStorage.getItem('auth0_user_id');
    const userId = localStorage.getItem('user_id');
    const payload = {
      userId:userId?Number(userId):0,
      givenName: formValue.dentistFirstName?.trim(),
      familyName: formValue.dentistLastName?.trim(),
      password: formValue.password,
      phoneNumber: formValue.phoneNumber,
      admin: false,
      authUserId: auth0_user_id
    };
    this.sharedService.updateAuth0User(payload).subscribe({
      next: (res) => {
        this.heading = 'Edit profile confirmation'
        this.loader.hide();
        this.isUpdated = true;
        this.sharedService.updateUsername(`${payload.givenName} ${payload.familyName}`,)
        const userData = localStorage.getItem('loggedUserDetails')
        if(userData){
          const userDetails = JSON.parse(userData);
          userDetails.firstName = payload.givenName
          userDetails.lastName = payload.familyName
          userDetails.phoneNumber = payload.phoneNumber
          localStorage.setItem('loggedUserDetails', JSON.stringify(userDetails));
        }
      },
      error: (err) => {
        this.loader.hide();
        const message = err?.error?.message || '';
        const authMessage = err?.error?.error?.message || ''
        this.sharedService.logError("APIFailed", "FileEdit-profileComponent - updateAuth0User, Method:updateProfile", this.router.url.split('?')[0], err).subscribe();
        if (message.includes('Password is too weak')) {
          this.profileForm.controls['password'].setErrors({
            customFieldValidation: true,
          });
        } else if(authMessage.includes('PasswordHistoryError: Password has previously been used')){
          this.mainError = 'Password has previously been used'
        }else {
          this.mainError = message;
        }
      },
    });
  }
}
